module.exports = __webpack_public_path__ + "img/18.e83d8528.gif";